﻿// TOC positioning
; (() => {
    function setPxVar(name, val) {
        document.documentElement.style.setProperty(
            name,
            Math.max(0, Math.round(val)) + "px"
        );
    }

    function pageY(el) {
        return el.getBoundingClientRect().top + window.scrollY;
    }

    function positionToc() {
        const container = document.querySelector(".blog-post-hero .container");
        const aside = document.querySelector(".blog-aside");
        const card = document.querySelector(".blog-aside .blog-toc");
        const h1 =
            document.querySelector('[itemprop="headline"]') ||
            document.querySelector(".blog-layout-row h1");

        if (!container || !aside || !card || !h1) return;

        // 1) Pin TOC to container's content edge
        const cRect = container.getBoundingClientRect();
        const cPadL = parseFloat(getComputedStyle(container).paddingLeft) || 0;
        const left = cRect.left + window.scrollX + cPadL;
        aside.style.left = left + "px";

        // 2) Align TOC top with H1 top
        const extra = Math.max(0, pageY(h1) - pageY(container));
        setPxVar("--toc-top-extra", extra);

        // 3) Offset article by real TOC width
        const width = card.getBoundingClientRect().width;
        setPxVar("--toc-width", width);
    }

    const raf = () => requestAnimationFrame(positionToc);

    window.addEventListener("DOMContentLoaded", raf);
    window.addEventListener("load", raf);
    window.addEventListener("resize", raf);

    if (document.fonts && document.fonts.addEventListener) {
        document.fonts.addEventListener("loadingdone", raf);
    }

    const article = document.querySelector(".blog-article");
    if (window.ResizeObserver && article) {
        const ro = new ResizeObserver(raf);
        ro.observe(article);
    }
})();


// Remove Word / Grammarly spans
; (() => {
    function unwrap(node) {
        const parent = node.parentNode;
        if (!parent) return;
        while (node.firstChild) {
            parent.insertBefore(node.firstChild, node);
        }
        parent.removeChild(node);
    }

    document.addEventListener("DOMContentLoaded", () => {
        const article = document.querySelector(".blog-article");
        if (!article) return;

        article
            .querySelectorAll(
                "span.SpellingErrorV2Themed, span.ContextualSpellingAndGrammarErrorV2Themed"
            )
            .forEach(unwrap);
    });
})();


// Lead capture AJAX
; (() => {
    document.addEventListener("DOMContentLoaded", () => {
        const forms = document.querySelectorAll(".lead-capture-form");
        if (!forms.length) return;

        forms.forEach((form) => {
            form.addEventListener("submit", async (e) => {
                e.preventDefault();

                const sectionId = form.getAttribute("data-section-id");
                const msgHost = document.querySelector(
                    '.lead-message[data-lead-message="' + sectionId + '"]'
                );

                if (msgHost) msgHost.innerHTML = "";

                const submitBtn =
                    form.querySelector('button[type="submit"]') ||
                    form.querySelector("button");

                const originalText = submitBtn ? submitBtn.textContent : null;

                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.textContent = "Sending...";
                }

                const formData = new FormData(form);

                try {
                    const response = await fetch(form.action, {
                        method: "POST",
                        body: formData,
                        headers: { "X-Requested-With": "XMLHttpRequest" }
                    });

                    let payload = null;
                    try {
                        payload = await response.json();
                    } catch (_) { }

                    const success = payload?.success ?? response.ok;
                    const message =
                        payload?.successMessage ||
                        payload?.errorMessage ||
                        (success
                            ? "The document has been emailed to you."
                            : "We could not send the email. Please try again.");

                    if (msgHost) {
                        msgHost.innerHTML =
                            '<div class="alert ' +
                            (success ? "alert-success" : "alert-danger") +
                            ' mt-3">' +
                            message +
                            "</div>";
                    } else {
                        alert(message);
                    }
                } catch (err) {
                    if (msgHost) {
                        msgHost.innerHTML =
                            '<div class="alert alert-danger mt-3">Something went wrong. Please try again.</div>';
                    } else {
                        alert("Something went wrong. Please try again.");
                    }
                } finally {
                    if (submitBtn) {
                        submitBtn.disabled = false;
                        if (originalText) submitBtn.textContent = originalText;
                    }
                }
            });
        });
    });
})();
